import React, { FC, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { linkOutreachInstall } from "../../services/firebase";
import Loading, { LoadingVariant } from "../../components/Display/Loading";

/**
 * Where Outreach sends an admin after they install boring's Outreach app (the
 * app's setup URL). The setup token is good for 15 minutes; linking it lets
 * boring post LinkedIn activity as its own cards in the prospect activity feed.
 */
const OutreachInstallRedirect: FC = () => {
  const { search } = useLocation();
  const token = new URLSearchParams(search).get("installSetupToken") || "";
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setMessage("This link is missing Outreach's setup token. Install boring's app from Outreach again.");
      return;
    }
    let cancelled = false;
    linkOutreachInstall(token)
      .then((data) => {
        if (cancelled) return;
        setMessage(data?.result?.linked ? "boring's Outreach app is installed. LinkedIn activity now shows in the prospect activity feed as boring events." : data?.result?.reason || "Outreach did not accept the installation.");
      })
      .catch(() => !cancelled && setMessage("boring could not finish the installation. Sign in to boring as an admin and open this link again."));
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (!message) {
    return (
      <div className="d-flex h-100 align-items-center justify-content-center m-auto">
        <Loading variant={LoadingVariant.CIRCULAR} />
      </div>
    );
  }
  return (
    <div className="d-flex h-100 flex-column align-items-center justify-content-center m-auto gap-3 text-center" style={{ maxWidth: 480 }}>
      <p className="mb-0">{message}</p>
      <a className="btn btn-light" href="/app/dashboard">
        Open boring
      </a>
    </div>
  );
};

export default OutreachInstallRedirect;
